// Global error handler to prevent duplicate error messages
class ErrorHandler {
  private static instance: ErrorHandler;
  private lastErrorTime: number = 0;
  private lastErrorMessage: string = '';
  private readonly DEBOUNCE_TIME = 2000; // 2 seconds

  static getInstance(): ErrorHandler {
    if (!ErrorHandler.instance) {
      ErrorHandler.instance = new ErrorHandler();
    }
    return ErrorHandler.instance;
  }

  shouldShowError(message: string): boolean {
    const now = Date.now();
    
    // If it's the same error message and it's within the debounce time, don't show it
    if (this.lastErrorMessage === message && (now - this.lastErrorTime) < this.DEBOUNCE_TIME) {
      console.log('[ErrorHandler] Suppressing duplicate error message:', message);
      return false;
    }
    
    // Update the last error info
    this.lastErrorTime = now;
    this.lastErrorMessage = message;
    return true;
  }

  reset(): void {
    this.lastErrorTime = 0;
    this.lastErrorMessage = '';
  }
}

export const errorHandler = ErrorHandler.getInstance();
